import React from 'react'
import { HiX } from 'react-icons/hi'
import classNames from 'classnames'

const CloseButton = React.forwardRef((props, ref) => {

	const { absolute, className, defaultStyle, svgClass, ...rest } = props
	const closeButtonAbsoluteClass = 'absolute z-10'

	const closeButtonClass = classNames(
		'close-btn',
		defaultStyle && 'close-btn-default',
		absolute && closeButtonAbsoluteClass,
		className
	)

	// A real button, so it takes keyboard focus and Enter/Space; callers can pass a better aria-label.
	return (
		<button
			type="button"
			aria-label="Close"
			className={closeButtonClass}
			{...rest}
			ref={ref}
		>
			<HiX aria-hidden="true" />
		</button>
	)
})

CloseButton.defaultProps = {
	defaultStyle: true
}

export default CloseButton
